import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';
import { useTenantContext } from '@/contexts/TenantContext';

export type AppRole = 'super_admin' | 'tenant_admin' | 'user';

export function useUserRole() {
  const { user } = useAuth();
  const { activeTenantId } = useTenantContext();

  const { data: roles = [], isLoading } = useQuery({
    queryKey: ['user-roles', user?.id, activeTenantId],
    queryFn: async () => {
      if (!user) return [];

      // Query for both tenant-specific roles AND global roles (tenant_id IS NULL)
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .or(activeTenantId 
          ? `tenant_id.eq.${activeTenantId},tenant_id.is.null`
          : 'tenant_id.is.null'
        );

      if (error) throw error;
      return data.map(r => r.role as AppRole);
    },
    enabled: !!user,
  });

  const isSuperAdmin = roles.includes('super_admin');
  
  console.log('🔐 useUserRole Debug:', { 
    roles, 
    isSuperAdmin, 
    activeTenantId, 
    userId: user?.id 
  });

  return {
    roles,
    isLoading,
    isSuperAdmin,
    isTenantAdmin: roles.includes('tenant_admin') || roles.includes('super_admin'),
    isUser: roles.length > 0,
  };
}
